<template>
  <header>
    <a class="Header_header__91Nua" href="/">
      <img aria-hidden="true" alt="Fashion Make Up Game" class="rounded-lg"
        height="44"
        src="@/assets/img/bluebird/6.png"
        width="44"
      />
      <h1 class="ml-3 text-white font-bold">Fashion Make Up Game</h1>
    </a>
  </header>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
